export default __webpack_public_path__ + "static/media/thumbnail1.71e9338f.jpg";